import * as ActionTypes from '../../../../models/actionTypes';

export const diagnosticStart = (nodeId: string, packageName: string) => {
  return { type: ActionTypes.DIAGNOSTIC_RUN_START, payload: { nodeId, packageName } };
};

export const diagnosticCompletion = (result: string) => {
  return { type: ActionTypes.DIAGNOSTIC_RUN_COMPLETE, payload: result };
};

export const diagnosticError = (result: string) => {
  return { type: ActionTypes.DIAGNOSTIC_RUN_ERROR, payload: result };
};

export const diagnosticTimeout = () => {
  return { type: ActionTypes.DIAGNOSTIC_RUN_TIMEOUT };
};
